import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { signOutSuccess } from "../../redux/userRedux";
import { auth } from "../../firebase";
import { useDispatch } from "react-redux";

const DropDownMenu = ({ isOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (!isOpen) return null;

  const handleSignOut = async () => {
    await signOut(auth);
    dispatch(signOutSuccess());
    navigate("/home");
  };

  const menuItems = [
    { label: "Profile", action: () => navigate("/profilepage") },
    { label: "Cases", action: () => navigate("/caselist") },
    { label: "Contact", action: () => navigate("/contact") },
  ];

  return (
    <div
      className="absolute right-8 w-56 z-50 rounded-xl overflow-hidden"
      style={{
        top: "100%",
        marginTop: "6px",
        backgroundColor: "#13171F",
        border: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
      }}
    >
      <ul className="py-1">
        {menuItems.map((item) => (
          <li
            key={item.label}
            onClick={item.action}
            className="px-4 py-3 text-sm cursor-pointer transition-colors duration-150"
            style={{ color: "#94A3B8" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.06)";
              e.currentTarget.style.color = "#E7EBEF";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#94A3B8";
            }}
          >
            {item.label}
          </li>
        ))}

        {/* Divider */}
        <li style={{ height: "1px", backgroundColor: "rgba(255,255,255,0.08)", margin: "4px 0" }} />

        {/* Sign out */}
        <li
          onClick={handleSignOut}
          className="px-4 py-3 text-sm cursor-pointer transition-colors duration-150"
          style={{ color: "#F87171" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.08)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          Log Out
        </li>
      </ul>
    </div>
  );
};

export default DropDownMenu;
